import { Link } from "react-router-dom";
import { useState } from "react";

const UserAccountsModal = ({ data }) => {
  const [index, setIndex] = useState(0);

  const handleNext = () => {
    setIndex(index + 1);
  };
  const handlePrev = () => {
    setIndex(index - 1);
  };
  return (
    <div className={`relative flex flex-col justify-start items-center top-[30px] left-[815px] w-[243.5px] h-[364px] text-darkslategray`}>
      <div className={`rounded-mini bg-white shadow-[-10.383894920349121px_-8.495914459228516px_28.32px_rgba(0,_0,_0,_0.35),_12.271876335144043px_11.327885627746582px_28.32px_rgba(0,_0,_0,_0.35)] backdrop-blur-lg absolute inset-0 w-[243.5px] h-[364px]`} />
      <img
        className="absolute top-[-9px] right-[16px] w-[13px] h-[10px]"
        alt=""
        src="/arrow.svg"
      />
      <div className="z-0 mt-[13px] font-semibold text-yellowgreen w-[135.03px] h-[24.05px]">
        User Accounts
      </div>
      <img
        className="z-0 mt-[5px] w-[245.5px] h-0.25"
        alt=""
        src="/seprator.svg"
      />
      <div className="z-0 mt-[13px] font-semibold w-42 text-[12px]">
        {data[index].title}
      </div>
      <div className="z-0 mt-[7px] text-[10px] mx-3 w-[220px] text-center">
        {data[index].text}
      </div>
      <div
        style={{
          borderRadius: "10px",
          overflow: "hidden",
        }}
        className="z-0 mt-[10px] rounded-3xs w-[189px] h-[112.75px] object-cover cursor-pointer"
        alt=""
        src="/video-screen@2x.png"
      >
        <iframe
          width="100%"
          height="100%"
          src={data[index].videoURL}
          frameborder="0"
          allow="fullscreen"
        ></iframe>
      </div>
      <img
        className="z-0 mt-[8px] w-[30px] h-[5px]"
        alt=""
        src={`/${data[index].dots}`}
      />
      <img
        className="z-0 mt-[15px] w-[245.5px] h-0.25"
        alt=""
        src="/seprator1.svg"
      />
      <div className="absolute h-[6.16%] w-[64.18%] top-[90%] right-[18.09%] bottom-[4.31%] left-[17.73%] text-xs">
        {index === 0 ? (
          <Link to="/">
            <div className="absolute h-full w-[47.85%] top-[0%] right-[52.15%] bottom-[0%] left-[0%] cursor-pointer">
              <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-mini bg-lightsteelblue" />
              <div className="absolute text-darkslategray text-[9px] w-full top-[23.33%] left-[0%] inline-block">
                Previous
              </div>
            </div>
          </Link>
        ) : (
          <div className="absolute h-full w-[47.85%] top-[0%] right-[52.15%] bottom-[0%] left-[0%] cursor-pointer">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-mini bg-lightsteelblue" />
            <div
              className="absolute text-darkslategray text-[9px] w-full top-[23.33%] left-[0%] inline-block"
              onClick={handlePrev}
            >
              Previous
            </div>
          </div>
        )}
        {index < data.length - 1 ? (
          <div className="absolute h-full w-[47.85%] top-[0%] right-[0%] bottom-[0%] left-[52.15%] text-white cursor-pointer">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-[25px] bg-yellowgreen" />
            <div
              className="absolute text-[9px] w-full top-[20%] left-[0%] inline-block"
              onClick={handleNext}
            >
              Continue
            </div>
          </div>
        ) : (
          <Link to="/network">
            <div className="absolute h-full w-[47.85%] top-[0%] right-[0%] bottom-[0%] left-[52.15%] text-white cursor-pointer">
              <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-[25px] bg-yellowgreen" />
              <div className="absolute text-[9px] w-full top-[20%] left-[0%] inline-block">
                Continue
              </div>
            </div>
          </Link>
        )}
      </div>
      <Link to="/home" className="decoration-transparent">
        <img
          className="absolute h-[13px] w-[13px] top-[4%] right-[4%] max-w-full overflow-hidden max-h-full"
          alt=""
          src="/close.svg"
        />
      </Link>
    </div>
  );
};

export default UserAccountsModal;
